import React from 'react';
import { Link, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

// Actions
import { gameActions } from '../../actions';

import { GameForm } from './form';
import { GameSetup } from './setup';
import { GamePlayers } from './players';
import { GameLeaderboard } from './leaderboard';
import GameSalary from './salary';
import GameWaste from './waste';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
    };

    // Bindings
  }

  componentDidMount() {
    const { match } = this.props;
    const { id } = match.params;
    this.props.dispatch(gameActions.fetchGames(id));
  }

  componentDidUpdate(prevProps) {
    const { game, user, i18n } = this.props;
    const default_lang = game?.data?.default_lang;
    const i18nextSetBy = localStorage.getItem('i18nextSetBy');

    if (
      default_lang?.length > 0 &&
      i18nextSetBy !== user?.email &&
      prevProps.game?.data?.default_lang !== default_lang
    ) {
      console.log('Setting language to', default_lang);
      i18n.changeLanguage(default_lang);
      localStorage.setItem('i18nextSetBy', user?.email);
    }
  }

  render() {
    const { game, match } = this.props;
    // const { item } = this.state;
    const SetupComponent =
      game && game.data && game.data.access_type === 'lti-hbp'
        ? GameSetup
        : GameForm;

    return (
      <div>
        {game && game.data && (
          <div>
            <Route exact path={match.path} component={SetupComponent} />
            <Route
              exact
              path={match.path + '/players'}
              component={GamePlayers}
            />
            {/* <Route path={match.path + '/players'} render={ props => <GamePlayers {...props} item={item} /> } /> */}
            <Route
              exact
              path={match.path + '/debrief/salary'}
              component={GameSalary}
            />
            <Route
              exact
              path={match.path + '/debrief/waste'}
              component={GameWaste}
            />
            <Route
              exact
              path={match.path + '/debrief/leaderboard'}
              component={GameLeaderboard}
            />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, player, game } = state;
  return {
    user: authentication.user,
    game,
    player,
  };
}

const connectedGamesPage = connect(mapStateToProps)(withTranslation()(Form));
export { connectedGamesPage as GameItem };
